import script from "./item-status.vue?vue&type=script&setup=true&lang=js"
export * from "./item-status.vue?vue&type=script&setup=true&lang=js"

import "./item-status.vue?vue&type=style&index=0&id=6e9f1df2&lang=scss&scoped=true"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e9f1df2"]])

export default __exports__